import { render, staticRenderFns } from "./RecuperarSenha.vue?vue&type=template&id=e671de8c&scoped=true"
import script from "./RecuperarSenha.vue?vue&type=script&lang=js"
export * from "./RecuperarSenha.vue?vue&type=script&lang=js"
import style0 from "./RecuperarSenha.vue?vue&type=style&index=0&id=e671de8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e671de8c",
  null
  
)

export default component.exports